  import logo from '../images/logo.png'
  const Footer = () => (
  <>
      <section
    id="footer"
    className="text-white my-4 container"
    style={{ padding: 20 }}
  >
    <footer className="p-5 d-flex flex-column flex-md-row mx-auto g-3 justify-content-between align-items-center">
      <div className="footerLogo d-flex flex-column gap-3 justify-content-center align-items-center mb-4 mb-md-0">
        <div className="logo d-flex align-items-center">
          <img
            src={logo}
            style={{ width: 300, height: 300 }}
            className="img-fluid"
            id='#img-fluid'
            alt="Logo"
          />
        </div>
        <div>
          <p>
            All rights reserved <strong className='text-effect'>Uncle Sam</strong> © 2024
          </p>
        </div>
      </div>
      <div className="d-flex flex-column text-white justify-content-center align-items-center mb-4 mb-md-0">
        <div className="form__group field w-100">
          <div className="position-relative">
            <input
              type="input"
              className="form__field"
              style={{ width: "100%", transition: "0.1s" }}
              placeholder="Your Email"
              name="hisEmail"
              id="hisEmail"
              required=""
            />
            <i
              className="fa-solid fa-arrow-right position-absolute"
              style={{ right: 10, cursor: "pointer", padding: 5 }}
            />
          </div>
          <label htmlFor="hisEmail" className="form__label">
            Your Email
          </label>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center flex-column">
        <h3 className="text-center">Follow Me</h3>
        <ul className="d-flex justify-content-between">
          <li>
            <a href="https://www.linkedin.com/in/sami-muhammed/">
              <i className="fa-brands fa-linkedin text-primary" />
            </a>
          </li>
          <li>
            <a href="https://github.com/SemsemE4E5?tab=repositories" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-github text-white" style={{ fontSize: "24px", transition: "0.3s" }} />
            </a>
          </li>
          <li>
            <a href="https://wa.me/201025374656?text=Hello%20I'm%20interested%20in%20your%20services">
              <i className="fa-brands fa-whatsapp text-success" />
            </a>
          </li>
           <li>
            <a href="#footer">
              <i className="fa-brands fa-facebook text-primary" />
            </a>
          </li>
        </ul>
      </div>
    </footer>
  </section>
  <section id='footer' className='container mx-auto text-center p-5 d-flex flex-column flex-md-row justify-content-between align-items-center' >
    <h4 className='mx-auto text-white'>Made By <a className='btn btn-outline-success btn-lg w-75 say-hello py-0 px-0' href='https://www.linkedin.com/in/sami-muhammed/' target='_blank' rel="noreferrer">Uncle Sam Team</a></h4>
  </section>
  </>
  )

  export default Footer
  